import React from "react";
import Overview from "../Dependencies/resultsPage/overview";

export default function ResultPage(){
    return(
        <Overview/>
    );
}